import { DynamicWidgetType } from 'ecosystem'
import storefrontApi from 'api/storefront-api'
import { categoryFactory, dynamicPageWidgets } from 'api'
import { notFound } from 'next/navigation'
import type { StaticPath } from 'shared-utils'

export const getStaticPropsHandler = async <T>(
  slug: string,
  priceValues: {
    minPrice: number
    maxPrice: number
  },
  translations?: T
) => {
  const store = await storefrontApi.store.getStore({
    query: ['categories', 'deliveries']
  })
  const { category } = categoryFactory(slug, store.categories || [])

  if (!category) {
    return notFound()
  }

  const filterOptionsResponse = await storefrontApi.store.getFilterOptions({
    categoryIds: [category.id],
    filters: [],
    ...priceValues
  })

  const widgets = await dynamicPageWidgets(
    { id: category.id, type: 'category' },
    DynamicWidgetType.CATEGORY
  )

  const props = {
    ...translations,
    deliveryOptions: store.deliveries || null,
    category,
    widgets,
    filterConfig: {
      options: filterOptionsResponse?.options || [],
      brands: filterOptionsResponse?.brands || []
    }
  }

  return {
    props
  }
}

export const getStaticPathsHandler = async () => {
  const store = await storefrontApi.store.getStore({ query: ['categories'] })
  const mapper = (slug: string): StaticPath => ({ params: { slug } })
  const paths = store.categories
    ?.filter((_c) => _c.slug)
    .map((c) => c.slug)
    .map(mapper)
    .flat()

  return { paths: paths || [], fallback: 'blocking' }
}
